import SearchModalFadingWrapper from './SearchModalFadingWrapper';

export default SearchModalFadingWrapper;
